/**
 * Shared helpers for action-page + bio-hub block components.
 *
 * Extracted from ActionBlockRenderer.jsx during the v119 file-split so
 * commerce / engagement / contact / gate block groups can all reach the
 * same `_postPublicLead` capture endpoint without a circular import.
 */

/**
 * POST a public lead against whichever creator/page slug the visitor is
 * currently viewing. Throws on non-2xx so callers can display a toast.
 */
export async function _postPublicLead(block, extras) {
  const backend = process.env.REACT_APP_BACKEND_URL;
  const parts = window.location.pathname.split("/").filter(Boolean);
  if (parts[0] !== "u" || parts.length < 2) throw new Error("bad url");
  const creator_slug = parts[1];
  const page_slug = parts[2] || null;
  const url = page_slug
    ? `${backend}/api/public/pages/${creator_slug}/${page_slug}/leads`
    : `${backend}/api/public/creators/${creator_slug}/leads`;
  const res = await fetch(
    url,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...extras, block_id: block.block_id }),
    },
  );
  if (!res.ok) throw new Error("failed");
  return res.json();
}

/**
 * YouTube URL helpers. Extracted from ActionBlockRenderer.jsx so the
 * VideoPlaylistBlock (engagement.jsx) and the primary video block
 * (ActionBlockRenderer.jsx) can both use them without cross-module
 * import cycles. Root-cause fix for "Can't find variable: ytEmbed"
 * production crash on iOS Safari (v139.1).
 */
export function isYoutubeUrl(url) {
  return /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\//i.test(url || "");
}

export function ytEmbed(url) {
  if (!url) return null;
  const short = url.match(/youtu\.be\/([\w-]+)/);
  const long = url.match(/[?&]v=([\w-]+)/);
  const id = (short && short[1]) || (long && long[1]);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}
